// @ts-nocheck
let theme = {};
/**
 * Provides convenient utility functions for interacting with elements
 */
(() => {
  theme.elementUtil = {};

  theme.elementUtil.remove = (elem) => {
    if (elem) {
      if (typeof elem.remove === 'function') {
        elem.remove();
      } else {
        elem.forEach((thisElem) => {
          thisElem.remove();
        });
      }
    }
  };

  theme.elementUtil.isInViewport = (elem) => {
    const rect = elem.getBoundingClientRect();
    return (
      Math.round(rect.top) >= 0
      && Math.round(rect.left) >= 0
      && Math.round(rect.bottom) <= (window.innerHeight || document.documentElement.clientHeight)
      && Math.round(rect.right) <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };
})();

/**
 * Utility functions for interacting with LocalStorage/SessionStorage
 */
(() => {
  theme.storageUtil = {};

  theme.storageUtil.set = (key, value, isSession) => {
    if (isSession) {
      sessionStorage.setItem(
        `cc-${key}`,
        typeof value === 'object' ? JSON.stringify(value) : value
      );
    } else {
      localStorage.setItem(`cc-${key}`, typeof value === 'object' ? JSON.stringify(value) : value);
    }
  };

  theme.storageUtil.get = (key, isJson, isSession) => {
    let value = isSession ? sessionStorage.getItem(`cc-${key}`) : localStorage.getItem(`cc-${key}`);
    if (isJson) {
      value = JSON.parse(value);
    }
    return value;
  };

  theme.storageUtil.remove = (key, isSession) => {
    if (isSession) {
      sessionStorage.removeItem(`cc-${key}`);
    } else {
      localStorage.removeItem(`cc-${key}`);
    }
  };
})();

class CompareUtil {
  static getSelectedProducts() {
    const compareProducts = theme.storageUtil.get('compare-products', true);
    return compareProducts || [];
  }

  static setSelectedProducts(compareProducts) {
    theme.storageUtil.set('compare-products', compareProducts);
  }

  static addToCompare(productId, productUrl, updateDom) {
    const compareProducts = CompareUtil.getSelectedProducts();
    if (!compareProducts.some((product) => product.id === productId)) {
      compareProducts.push({ id: productId, url: productUrl });
    }
    CompareUtil.setSelectedProducts(compareProducts);
    CompareUtil.updateCompareCounters(compareProducts.length);

    if (updateDom) {
      CompareUtil.syncCompareState();
    }
  }

  static removeFromCompare(productId, updateDom) {
    let compareProducts = CompareUtil.getSelectedProducts();
    if (compareProducts) {
      compareProducts = compareProducts.filter((product) => product.id !== productId);
    }
    CompareUtil.setSelectedProducts(compareProducts);
    CompareUtil.updateCompareCounters(compareProducts.length);

    if (updateDom) {
      CompareUtil.syncCompareState();

      const element = document.getElementById(`compare-basket-${productId}`);
      if (element) {
        const sectionWrapper = element.closest('.shopify-section');
        if (sectionWrapper) {
          theme.elementUtil.remove(sectionWrapper);
        } else {
          theme.elementUtil.remove(element);
        }
      }

      theme.elementUtil.remove(document.querySelectorAll(`.compare-col--${productId}`));

      document.querySelectorAll('.compare-row').forEach((row) => {
        if (row.children.length === 0) {
          row.remove();
        }
      });
    }
  }

  static clearCompare(updateDom) {
    const compareProducts = CompareUtil.getSelectedProducts();
    if (compareProducts) {
      compareProducts.forEach((product) => {
        CompareUtil.removeFromCompare(product.id, updateDom);
      });
    }
  }

  static syncCompareState() {
    const compareProducts = CompareUtil.getSelectedProducts();
    document.querySelectorAll('.js-compare-checkbox').forEach((checkbox) => {
      const isChecked = compareProducts.filter(
        (product) => product.id === checkbox.dataset.productId
      ).length > 0;

      if (checkbox.checked !== isChecked) {
        checkbox.checked = isChecked;
      }

      const wrapper = checkbox.closest('.card__compare');
      if (wrapper) {
        const hasActive = wrapper.classList.contains('active');
        if (isChecked && !hasActive) {
          wrapper.classList.add('active');
        } else if (!isChecked && hasActive) {
          wrapper.classList.remove('active');
        }

        const compareText = wrapper.querySelector('.compare-text');
        if (compareText) {
          const newText = isChecked
            ? (compareText.dataset.addedText || 'Added to Compare')
            : (compareText.dataset.addText || 'Add to Compare');
          if (compareText.textContent !== newText) {
            compareText.textContent = newText;
          }
        }
      }
    });
  }

  // Used by Boost instant-search re-render integration.
  // Keep this method lightweight: only sync checkbox.checked.
  static updateCompareCheckboxes() {
    const compareProducts = CompareUtil.getSelectedProducts();
    document.querySelectorAll('.js-compare-checkbox').forEach((checkbox) => {
      checkbox.checked = compareProducts.filter(
        (product) => String(product.id) === String(checkbox.dataset.productId)
      ).length > 0;
    });
  }

  static getCompareCount() {
    return CompareUtil.getSelectedProducts().length;
  }

  static updateCompareCounters(pCount) {
    const count = pCount || CompareUtil.getCompareCount();
    document.querySelectorAll('.js-compare-counter').forEach((counter) => {
      counter.innerText = count;
    });
  }
}

// Backwards-compatible export for other theme scripts.
window.CompareUtil = CompareUtil;

let isCompareCheckboxEventsBound = false;

function bindCompareCheckboxEvents() {
  if (isCompareCheckboxEventsBound) return;
  isCompareCheckboxEventsBound = true;

  document.addEventListener(
    'click',
    (evt) => {
      const target = evt.target;
      if (!(target instanceof Element)) return;

      const compareWrapper = target.closest('.js-boost-compare-wrapper');
      if (!compareWrapper) return;

      const checkbox = compareWrapper.querySelector('.js-compare-checkbox');
      if (!checkbox) return;

      if (target === checkbox) {
        evt.stopPropagation();
        evt.stopImmediatePropagation();
        return;
      }

      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();

      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    },
    true
  );

  document.addEventListener(
    'mousedown',
    (evt) => {
      const target = evt.target;
      if (!(target instanceof Element)) return;
      if (!target.closest('.js-boost-compare-wrapper')) return;
    },
    true
  );

  document.addEventListener(
    'touchstart',
    (evt) => {
      const target = evt.target;
      if (!(target instanceof Element)) return;
      if (!target.closest('.js-boost-compare-wrapper')) return;
    },
    { capture: true, passive: false }
  );
}

function closeComparePopup() {
  const comparePopup = document.getElementById('compare-popup');
  const elementHtml = document.querySelector('html');

  if (comparePopup) {
    comparePopup.classList.remove('active');
    elementHtml.classList.remove('overflow-hidden');
  }
}

if (!customElements.get('compare-drawer')) {
  class CompareDrawer extends HTMLElement {
    constructor() {
      super();
      this.overlay = document.querySelector('.compare-overlay');
      this.openDrawerButton = document.querySelector('.js-open-compare-drawer');
      this.openDrawer = document.querySelector('compare-drawer');
      this.compareBasketArea = this.querySelector('.js-compare-basket');
      this.loadingSpinner = this.querySelector('.compare-loading-spinner');
      this.doCompareButton = this.querySelector('.js-trigger-compare');
      this.clearButton = this.querySelector('.js-clear-compare');
      this.maxCompare = this.dataset.maxCompare;
      this.compareModal = document.querySelector('.js-compare-modal');
      this.basketCache = {};
      this.init();
      this.bindEvents();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._clickHandler);
      document.removeEventListener('change', this._changeHandler);
    }

    init() {
      CompareUtil.syncCompareState();
      CompareUtil.updateCompareCounters();
      this.toggleCompareButton();
      setTimeout(() => {
        this.openDrawerButton.removeAttribute('style');
        this.openDrawerButton.classList.add('transition-ready');
      }, 500);

      const detailsModal = this.compareModal.querySelector('.details-modal');
      if (detailsModal) {
        detailsModal.classList.remove('hidden');
      }
    }

    bindEvents() {
      this._clickHandler = this.handleClick.bind(this);
      this._changeHandler = this.handleChange.bind(this);

      document.addEventListener('click', this._clickHandler);
      document.addEventListener('change', this._changeHandler);
      this.doCompareButton.addEventListener('click', this.handleDoCompareClick.bind(this));
      this.clearButton.addEventListener('click', this.handleClearCompareClick.bind(this));
    }

    toggleCompareButton() {
      if (CompareUtil.getCompareCount() === 0) {
        this.openDrawerButton.classList.add('is-out');
        document.body.classList.remove('has-compare');
      } else {
        this.openDrawerButton.classList.remove('is-out');
        document.body.classList.add('has-compare');
      }
    }

    handleClick(evt) {
      if (evt.target === this.openDrawerButton || this.openDrawerButton.contains(evt.target)) {
        if (this.openDrawerButton.classList.contains('is-open')) {
          this.close();
        } else {
          this.open(this.openDrawerButton);
        }
      } else if (evt.target.classList.contains('js-compare-basket-remove')) {
        CompareUtil.removeFromCompare(evt.target.dataset.productId.toString(), true);
        this.updateBasketState();
      } else if ((this.overlay && evt.target === this.overlay) || evt.target.closest('.js-close-compare')) {
        this.close();
      } else if (this.hasAttribute('open') && this.contains(evt.target)) {
        this.close();
      }
    }

    showCompareConfirmPopup() {
      const locationPopup = document.getElementById('compare-popup');
      const elementHtml = document.querySelector('html');
      if (locationPopup.classList.contains('active')) {
        locationPopup.classList.remove('active');
        elementHtml.classList.remove('overflow-hidden');
      } else {
        locationPopup.classList.add('active');
        elementHtml.classList.add('overflow-hidden');
      }
    }

    handleChange(evt) {
      if (evt.target.classList.contains('js-compare-checkbox')) {
        const productData = evt.target.dataset;

        if (evt.target.checked) {

          if (CompareUtil.getCompareCount() < this.maxCompare) {
            CompareUtil.addToCompare(
              productData.productId.toString(),
              productData.productUrl,
              false
            );
            this.appendBasketProduct(productData.productId.toString(), productData.productUrl);
          } else {
            evt.target.checked = false;
            this.showCompareConfirmPopup();
          }
        } else {
          CompareUtil.removeFromCompare(productData.productId.toString(), true);
          this.invalidateCache(productData.productId.toString());
        }

        this.updateBasketState();
        CompareUtil.syncCompareState();

        if (CompareUtil.getCompareCount() > 0) {
          this.toggleCompareButton();
        }
      }

      const closePopup = document.querySelectorAll('.compare-popup .close-popup');
      if (closePopup) {
        closePopup.forEach(item => {
          item.addEventListener('click', function() {
            closeComparePopup();
          });
        });
      }
    }

    handleDoCompareClick() {
      this.close();

      const headerSection = document.querySelector('.header-section');
      if (headerSection) {
        headerSection.style.zIndex = '7';
      }

      this.compareModal.dispatchEvent(new CustomEvent('on:product-compare-modal:open'), { bubbles: true });
    }

    handleClearCompareClick() {
      CompareUtil.clearCompare(true);
      this.invalidateCache();
      this.openDrawerButton.style.display = 'none';
      this.openDrawer.style.display = 'none';
      document.body.classList.remove('has-compare');
      this.close();

      if (this.compareModal && typeof this.compareModal.close === 'function') {
        this.compareModal.close();
      }
    }

    async open(opener) {
      opener.classList.add('is-open');
      if (this.overlay) {
        //this.overlay.classList.add('is-visible');
      }
      this.setAttribute('open', '');
      this.setAttribute('aria-hidden', 'false');
      this.renderCompareBasket();
    }

    close() {
      this.openDrawerButton.classList.remove('is-open');
      if (this.overlay) {
        this.overlay.classList.remove('is-visible');
      }
      this.removeAttribute('open');
      this.setAttribute('aria-hidden', 'true');
    }

    updateBasketState() {
      const compareCount = CompareUtil.getCompareCount();
      this.doCompareButton.disabled = compareCount < 2;
      this.doCompareButton.classList.toggle('is-disabled', compareCount < 2);
      theme.elementUtil.remove(this.compareBasketArea.querySelector('.js-select-more'));
      theme.elementUtil.remove(this.compareBasketArea.querySelector('.js-select-one'));

      const continueButton = `<button class='js-close-compare link'>${window.compare.continue}</button>`;

      if (compareCount === 1) {
        document.body.classList.add('has-compare');
        this.openDrawerButton.style.display = 'flex';
        this.openDrawer.style.display = 'flex';
        this.compareBasketArea.innerHTML += `<div class='compare-prompt text-sm js-select-more'><p>${window.compare.more}</p> ${continueButton}</div>`;
      } else if (compareCount === 0) {
        document.body.classList.remove('has-compare');
        this.openDrawerButton.style.display = 'none';
        this.openDrawer.style.display = 'none';
        this.close();
        this.compareBasketArea.innerHTML += `<div class='compare-prompt text-sm js-select-one'><p>${window.compare.empty}</p> ${continueButton}</div>`;
      }
    }

    clearBasketArea() {
      Array.from(this.compareBasketArea.children).forEach((child) => {
        if (child !== this.loadingSpinner) {
          child.remove();
        }
      });
    }

    async renderCompareBasket() {
      const compareProducts = CompareUtil.getSelectedProducts();
      if (compareProducts && compareProducts.length > 0) {
        this.showLoading(true);
        this.clearBasketArea();

        const compareProductHtmlArr = await this.getBasketProducts(compareProducts);
        compareProductHtmlArr.forEach((compareProductHtml) => {
          if (compareProductHtml) {
            this.compareBasketArea.insertAdjacentHTML('beforeend', compareProductHtml);
          }
        });

        this.showLoading(false);
        this.updateBasketState();
      }
    }

    showLoading(isLoading) {
      if (isLoading) {
        this.loadingSpinner.removeAttribute('hidden');
        this.loadingSpinner.removeAttribute('aria-hidden');
        this.openDrawerButton.classList.add('is-loading');
      } else {
        this.loadingSpinner.setAttribute('hidden', 'true');
        this.loadingSpinner.setAttribute('aria-hidden', 'true');
        this.openDrawerButton.classList.remove('is-loading');
      }
    }

    invalidateCache(productId) {
      if (productId) {
        delete this.basketCache[productId];
      } else {
        this.basketCache = {};
      }
    }

    preloadBasketProduct(productId, productUrl) {
      if (!this.basketCache[productId]) {
        fetch(`${productUrl}?sections=product-compare-basket`)
          .then((response) => response.ok ? response.json() : null)
          .then((data) => {
            if (data) {
              this.basketCache[productId] = data['product-compare-basket'];
            }
          })
          .catch(() => {});
      }
    }

    insertBasketProductHtml(productId, html) {
      if (!html) return;
      if (document.getElementById(`compare-basket-${productId}`)) return;

      const prompt = this.compareBasketArea.querySelector('.js-select-more, .js-select-one');
      if (prompt) {
        prompt.insertAdjacentHTML('beforebegin', html);
      } else if (this.loadingSpinner && this.compareBasketArea.contains(this.loadingSpinner)) {
        this.loadingSpinner.insertAdjacentHTML('afterend', html);
      } else {
        this.compareBasketArea.insertAdjacentHTML('beforeend', html);
      }
    }

    async appendBasketProduct(productId, productUrl) {
      if (this.basketCache[productId]) {
        this.insertBasketProductHtml(productId, this.basketCache[productId]);
        return;
      }

      try {
        const response = await fetch(`${productUrl}?sections=product-compare-basket`);
        if (response.ok) {
          const data = await response.json();
          const html = data['product-compare-basket'];
          this.basketCache[productId] = html;
          this.insertBasketProductHtml(productId, html);
        }
      } catch (e) {
        // silently skip failed fetches
      }
    }

    async getBasketProducts(compareProducts) {
      const uncachedProducts = compareProducts.filter((p) => !this.basketCache[p.id]);

      if (uncachedProducts.length > 0) {
        await Promise.all(
          uncachedProducts.map(async (product) => {
            try {
              const response = await fetch(`${product.url}?sections=product-compare-basket`);
              if (response.ok) {
                const data = await response.json();
                this.basketCache[product.id] = data['product-compare-basket'];
              }
            } catch (e) {
              // silently skip failed fetches
            }
          })
        );
      }

      return compareProducts.map((product) => this.basketCache[product.id] || '');
    }
  }

  customElements.define('compare-drawer', CompareDrawer);
}

document.addEventListener("DOMContentLoaded", function() {
  bindCompareCheckboxEvents();
  setTimeout(() => {
    CompareUtil.syncCompareState();
  }, 2000);
});
